export type urlsFields = {
  home: string;

  //navigation
  exchangeRateApp: string;
  weatherApp: string;
  gpApp: string;
};

export const appUrls: urlsFields = {
  home: '/',

  //navigation
  exchangeRateApp: '/exchange-rate',
  weatherApp: '/forecast',
  gpApp: '/your-gp-calendar',
};
